import type { Project } from '../../project/types/project';

/** True when any project type has Pipe Fitter feature enabled. */
export function isProjectPipeFitterEnabled(project: Project | null | undefined): boolean {
  const pt = project?.projectTypes;
  if (!pt) return false;
  if (pt.pipeline?.features?.pipeFitter?.enabled) return true;
  if (pt.others?.features?.pipeFitter?.enabled) return true;
  const fab = pt.fabrication?.options;
  if (fab?.buckleArrestor?.features?.pipeFitter?.enabled) return true;
  if (fab?.pipeInPipe?.features?.pipeFitter?.enabled) return true;
  if (fab?.bulkhead?.features?.pipeFitter?.enabled) return true;
  if ((fab as { spools?: { features?: { pipeFitter?: { enabled?: boolean } } } })?.spools
    ?.features?.pipeFitter?.enabled) {
    return true;
  }
  return false;
}
